import { useTranslation } from 'react-i18next'
import { useMoney } from '@/lib/hooks/useMoney'
import { isFreePrice } from '@/lib/products/kinds'

/**
 * One way to write a product's price: "Free" at zero, the formatted amount
 * otherwise (F-74). Lists, cards and buttons all go through it.
 */
export function usePriceLabel() {
  const { t } = useTranslation('products')
  const formatMoney = useMoney()
  return (price: number | string | null | undefined, currency?: string): string =>
    isFreePrice(price) ? t('free') : formatMoney(Number(price) || 0, currency)
}
